import pkg from './';
export default pkg.setup();
